<template>
    <div class="help_content">
        <div class="help_btn">
            <div class="help_content_menc" v-if="bShowHelp" @click.stop="getCha(undefined)"></div>
            <img src="@/assets/images/user/house/help-icon.png" alt="" @click.stop="getCha(undefined)">
            <!-- <transition name="fade-transform" mode="out-in"> -->
                <div class="help_warp_list" v-if="bShowHelp">
                    <div class="help_list_title">定位及预留要求</div>
                    <div class="help_list" @click.stop>
                        <div :class="[nHelpnum == index?'help_list_aitv':'']" v-for="(item,index) in arrHelpList" :key="index" @click="getCha(index)">{{item.name}}</div>
                    </div>
                </div>
            <!-- </transition> -->
        </div>
    </div>
</template>

<script>
export default {
    props: {
        bShowHelp: {
            type: Boolean,
            default: () => false,
        },
    },
    data() {
        return {
            nHelpnum: 0,
            arrHelpList: [
                { name: "室外机" },
                { name: "室内机" },
                { name: "壁挂炉" },
                { name: "风机盘管" },
                { name: "分集水器" },
                { name: "新风机组" },
                { name: "控制类" },
                { name: "孔洞定位" },
                { name: "偏差说明" },
                { name: "偏差说明" },
                { name: "偏差说明" },
                { name: "偏差说明" },
                { name: "偏差说明" },
            ],
        };
    },
    methods:{
        getCha(num){
            if(num != undefined){
                this.nHelpnum = num;
            }
            this.$emit('update:bShowHelp',!this.bShowHelp);
        }
    }
};
</script>
<style lang="scss" scoped>
.fade-transform-leave-active,
.fade-transform-enter-active {
    transition: all 0.6s;
}
.fade-transform-enter {
    opacity: 0;
    transform: translateY(-30px);
}
.fade-transform-leave-to {
    opacity: 0;
    transform: translateY(-30px);
}
.help_content {
    position: relative;
}
.help_content_menc {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    background: rgba($color: #000000, $alpha: 0.7);
    animation: openiav 0.3s;
}
.help_btn {
    position: fixed;
    left: 562px;
    bottom: 120px;
    width: 156px;
    height: 156px;
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
        position: relative;
        z-index: 999;
    }
    .help_warp_list {
        position: absolute;
        top: -732px;
        width: 176px;
        height: 712px;
        background: #fff;
        border-radius: 20px;
        overflow: hidden;
        .help_list_title {
            width: 100%;
            padding: 16px 30px;
            height: 96px;
            box-sizing: border-box;
            font-size: 24px;
            color: #fff;
            background: $deepGreen;
            text-align: center;
        }
        .help_list {
            padding: 0 16px;
            box-sizing: border-box;
            height: 616px;
            overflow: auto;
            div {
                width: 100%;
                height: 68px;
                border-bottom: 1px solid #f1f1f1;
                box-sizing: border-box;
                font-size: 24px;
                color: #a2a2a2;
                display: flex;
                align-items: center;
                justify-content: center;
                &:last-child {
                    border-bottom: 0;
                }
            }
            .help_list_aitv {
                color: #444444;
            }
        }
    }
}
@keyframes openiav {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
</style>